export const focarCursorNaTela = (ref) => {
    if (ref?.current) {
        ref.current.focus();
    };
};

export const atrasarFocoInput = (ref, metodo, tempo) => {
    setTimeout(() => {
        if (ref?.current) {
            if (metodo === 'focus') {
                ref.current.focus();
            } else if (metodo === 'select' && typeof ref.current.select === 'function') {
                ref.current.select();
            }
        }
    }, tempo);
};